import React, { useState } from 'react';
import '../../style/LogIn.scss';
//Bootstrap
import { Form, Button, Spinner } from 'react-bootstrap';
// react router
import { Link } from 'react-router-dom';
// firebase
import app from '../firebase/fire';
function LogIn() {
  const [email, setEmail] = useState(null);
  const [password, setPassword] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const login = async (email, password) => {
    setIsLoading(true);
    try {
      await app.auth().signInWithEmailAndPassword(email, password);
      setIsLoading(false);
    } catch (error) {
      alert(error.message);
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className='d-flex align-items-center justify-content-center vh-100'>
        <Spinner animation='border' role='status' variant='warning'>
          <span className='sr-only'>Loading...</span>
        </Spinner>
      </div>
    );
  }

  return (
    <div className='logIn vh-100 d-flex align-items-center flex-column'>
      <div className='logInContainer'>
        <Form>
          <h2>བོད་ཀྱི་དྲྭ་མཉེན་བཟོ་སྐྲུན་ཁང།</h2>
          <hr />

          <Form.Group controlId='formBasicEmail'>
            <Form.Control
              type='email'
              placeholder='Enter email'
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
          </Form.Group>

          <Form.Group controlId='formBasicPassword'>
            <Form.Control
              type='password'
              placeholder='Password'
              onChange={(e) => {
                setPassword(e.target.value);
              }}
            />
          </Form.Group>
          <Button
            variant='info'
            // type='submit'
            onClick={() => login(email, password)}
          >
            Log In
          </Button>
        </Form>
      </div>
      <div className='mt-0'>
        <p>
          Go Back <Link to='/'> Home 🏠</Link>
        </p>
      </div>
    </div>
  );
}
export default LogIn;
